import { Servicio2 as c } from "../EditPanel/Servicio2";
import { conLanding } from "../Models/Landing";

export default class Servicio2 extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}